import { motion, useMotionValue, useSpring, useTransform, useReducedMotion } from "framer-motion";

/**
 * EventCard — full poster graphic (4:5) with a 3D perspective tilt on hover and
 * a light-reflection sweep (via the .card-sweep CSS class). The event graphics
 * already include title/date/time, so no text is overlaid.
 */
export default function EventCard({ event, testId }) {
  const reduced = useReducedMotion();
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const spring = { stiffness: 150, damping: 15, mass: 0.4 };
  const rotateX = useSpring(useTransform(my, [0, 1], [7, -7]), spring);
  const rotateY = useSpring(useTransform(mx, [0, 1], [-9, 9]), spring);

  const onMove = (e) => {
    if (reduced) return;
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const onLeave = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <motion.article
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={reduced ? {} : { rotateX, rotateY, transformPerspective: 1000 }}
      className="card-sweep group relative overflow-hidden rounded-3xl border border-white/10 shadow-[0_24px_70px_-24px_rgba(0,0,0,0.9)]"
      data-testid={testId}
    >
      <img
        src={event.image}
        alt={event.alt || event.title}
        loading="lazy"
        className="block w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
      />
      <span className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/10" />
    </motion.article>
  );
}
